import axios from "axios";
import { apiResponseError, apiResponseSuccess, loadingStart } from "./reducer";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8880";

export const getNotifications = () => async (dispatch) => {
  try {
    const response = await axios.get(`${API_URL}/v2/notification/my`, {
        headers: { token: "Bearer " + JSON.parse(localStorage.getItem("authUser")).accessToken }
    });
    dispatch(apiResponseSuccess({ actionType: "GET_NOTIFICATIONS", data: response }));
  } catch (error) {
    dispatch(apiResponseError(error.message));
  }
};

export const getNotificationHistory = () => async (dispatch) => {
  try {
    dispatch(loadingStart());
    const response = await axios.get(`${API_URL}/v2/notification/history`, {
        headers: { token: "Bearer " + JSON.parse(localStorage.getItem("authUser")).accessToken }
    });
    dispatch(apiResponseSuccess({ actionType: "GET_HISTORY", data: response }));
  } catch (error) {
    dispatch(apiResponseError(error.message));
  }
};

export const createNotification = (notification) => async (dispatch) => {
  try {
    dispatch(loadingStart());
    const response = await axios.post(`${API_URL}/v2/notification`, notification, {
        headers: { token: "Bearer " + JSON.parse(localStorage.getItem("authUser")).accessToken }
    });
    dispatch(apiResponseSuccess({ actionType: "ADD_NOTIFICATION", data: response }));
    // console.log("Туршилт - Backend response data:", response);
    toast.success("Мэдэгдэл амжилттай илгээгдлээ!", { autoClose: 3000 });
    return true;
  } catch (error) {
    const errMsg = error.response?.data?.error || error.response?.data || error.message;
    dispatch(apiResponseError(errMsg));
    toast.error(`Алдаа гарлаа: ${typeof errMsg === 'string' ? errMsg : JSON.stringify(errMsg)}`, { autoClose: 5000 });
    return false;
  }
};


export const markAsRead = (id) => async (dispatch) => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    await axios.patch(`${API_URL}/v2/notification/read/${id}`, {}, {
        headers: { token: "Bearer " + authUser.accessToken }
    });
    dispatch(apiResponseSuccess({ actionType: "MARK_READ", data: id, userId: authUser._id }));
  } catch (error) {
    console.error(error);
  }
};
